import axios from 'axios';
import * as AxiosRateLimiter from 'lib/AxiosRateLimiter';
import {jsonifyValue} from 'lib/StringUtils';
import moment from 'moment';

const BASE_URL = '/api/v2';
const DEFAULT_CONFIG = {_hideErrors: true};
let http;

export async function getPropertyPreferences(targetPropertyId) {
  const response = await axios.get(`${BASE_URL}/property-preferences/${targetPropertyId}`, DEFAULT_CONFIG);
  return response.data;
}

export async function updatePropertyPreferences(targetPropertyId, preferences) {
  if (!http) {
    http = AxiosRateLimiter.axiosRateLimit();
  }
  const promises = Object.keys(preferences).map((key) => {
    return http.put(`${BASE_URL}/property-preferences/${targetPropertyId}`, {
      created: moment.utc().toISOString(),
      key: key,
      value: jsonifyValue(preferences[key]),
    }, DEFAULT_CONFIG);
  });

  await Promise.all(promises);
}
